import React from "react";
import logo from "../assets/images/brand.png";
import Typography from "./typography/Typography";
import { Link } from "react-router-dom";

const explorePronttera = [
  { name: "Software Development", url: "https://pronttera.com/" },
  { name: "Data Science & Machine Learning", url: "" },
  { name: "DevOps", url: "" },
  { name: "Advanced AI & Machine Learning", url: "" },
  { name: "Masters in Software Development", url: "" },
];
const resources = [
  { name: "Alumni Reviews", url: "" },
  { name: "Blogs", url: "" },
  { name: "Contact Us", url: "" },
  { name: "Careers", url: "" },
  { name: "Slack", url: "" },
  { name: "Terms of Use", url: "terms-of-use" },
  { name: "Terms and Condition", url: "terms-and-conditions" },
  { name: "Privacy Policy", url: "privacy-policy" },
];
const others = [
  { name: "About Us", url: "about-us" },
  { name: "Become a Mentor", url: "" },
  { name: "Become a TA", url: "" },
  { name: "Hire from Us", url: "" },
];
const socials = [
  {
    platform: "YouTube",
    icon: "youtube-icon",
    url: "https://www.youtube.com/@Pronttera",
  },
  {
    platform: "LinkedIn",
    icon: "linkedin-icon",
    url: "https://www.linkedin.com/company/pronttera/?viewAsMember=true",
  },
  {
    platform: "Instagram",
    icon: "instagram-icon",
    url: "https://www.instagram.com/pronttera/",
  },
  {
    platform: "Twitter",
    icon: "twitter-icon",
    url: "https://x.com/pronttera",
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-blue-950 grid grid-cols-1 md:grid-cols-5 px-5 py-10 gap-3">
      <div className="">
        <img src={logo} alt="Logo" className="h-24" />
      </div>
      <ul className="flex flex-col gap-1">
        <Typography variant="li-gray" className="font-bold !text-white">
          Explore Pronttera Labs
        </Typography>
        {explorePronttera.map((explorePronttera) =>
          typeof explorePronttera === "string" ? (
            <Typography
              variant="li-gray"
              key={explorePronttera}
              className="!text-slate-300"
            >
              {explorePronttera}
            </Typography>
          ) : (
            <Typography
              variant="li-gray"
              key={explorePronttera.name}
              className="!text-slate-300"
            >
              <Link to={explorePronttera.url} className="hover:underline" target="_blank">
                {explorePronttera.name}
              </Link>
            </Typography>
          )
        )}
      </ul>
      <ul className="flex flex-col gap-1">
        <Typography variant="li-gray" className="font-bold !text-white">
          Resources
        </Typography>
        {resources.map((resource) =>
          typeof resource === "string" ? (
            <Typography
              variant="li-gray"
              key={resource}
              className="!text-slate-300"
            >
              {resource}
            </Typography>
          ) : (
            <Typography
              variant="li-gray"
              key={resource.name}
              className="!text-slate-300"
            >
              <Link to={resource.url} className="hover:underline" >
                {resource.name}
              </Link>
            </Typography>
          )
        )}
      </ul>
      <ul className="flex flex-col gap-1">
        <Typography variant="li-gray" className="font-bold !text-white">
        Others
        </Typography>
        {others.map((others) =>
          typeof others === "string" ? (
            <Typography
              variant="li-gray"
              key={others}
              className="!text-slate-300"
            >
              {others}
            </Typography>
          ) : (
            <Typography
              variant="li-gray"
              key={others.name}
              className="!text-slate-300"
            >
              <Link to={others.url} className="hover:underline" >
                {others.name}
              </Link>
            </Typography>
          )
        )}
      </ul>
      <ul className="flex flex-col gap-1">
        <Typography variant="li-gray" className="font-bold !text-white">
          Socials
        </Typography>
        {socials.map((social) => (
          <Typography
            variant="li-gray"
            className="!text-slate-300"
            key={social.platform}
          >
            <a
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              {social.platform}
            </a>
          </Typography>
        ))}
      </ul>
    </footer>
  );
}
